import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { NavigationSkipped, NavigationStart, Router } from '@angular/router';
import { OverlayModel } from './overlay.model';
import { timeout } from '../../tools/event-tool';
import { NotificationService } from '../shared/services';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root'
})
export class OverlayService {
	defaultOverlay: OverlayModel = { isShow: false, component: null };
	public overlaySubject = new BehaviorSubject<OverlayModel>(this.defaultOverlay);
	overlayState$ = this.overlaySubject.asObservable();
	hasPushState = false;
	routerObserver = toSignal(
		this.router.events.pipe(
			tap(e => {
				if ((e instanceof NavigationSkipped || e instanceof NavigationStart) && this.hasPushState) {
					this.hideOverlay(true);
				}
			})
		)
	);
	routerObserver$ = toObservable(this.routerObserver);
	constructor(
		private router: Router,
		private notificationService: NotificationService
	) {}

	hideOverlay(withNavigation = false) {
		this.notificationService.changeNotifyOrderFormState(false);
		this.overlaySubject.next({ ...this.overlaySubject.value, isShow: false });
		// to close panel smoothly
		if (!withNavigation && this.hasPushState) history.go(-1);
		this.hasPushState = false;
		timeout(() => this.overlaySubject.next(this.defaultOverlay), 250);
	}
	//Hesamtodo need to review
	showOverlay(overlayModel: OverlayModel, pushState = true) {
		if (
			overlayModel?.option?.overWrite &&
			overlayModel?.option?.componentName === this.overlaySubject.value?.option?.componentName
		)
			return;
		this.notificationService.changeNotifyOrderFormState(true);
		this.overlaySubject.next({ ...overlayModel, isShow: true });
		if (pushState) history.pushState(null, '');
		this.hasPushState = pushState;
	}
}
